module.exports = __webpack_public_path__ + "img/privacy.2d14fa81.jpg";